"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Renderables_1 = require("../Renderables");
var ChoiceContainer_1 = require("./ChoiceContainer");
var Choice_1 = require("./Choice");
/**
 * Single choice container consisting of a radio
 * check box. The class single-choice is added for
 * CSS manipulations.
 *
 * @see {@link ChoiceContainer}
 * @see {@link ChoiceMutator}
 */
var SingleChoice = /** @class */ (function (_super) {
    __extends(SingleChoice, _super);
    function SingleChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleChoice.prototype.cssClassName = function () {
        return "single-choice";
    };
    SingleChoice.prototype.mutatedChoiceType = function () {
        return "radioChoice";
    };
    return SingleChoice;
}(ChoiceContainer_1.ChoiceContainer));
exports.SingleChoice = SingleChoice;
/**
 * Multi choice container consisting of check
 * boxes. The class multiple-choice is added for
 * CSS manipulations.
 *
 * @see {@link ChoiceContainer}
 * @see {@link ChoiceMutator}
 */
var MultipleChoice = /** @class */ (function (_super) {
    __extends(MultipleChoice, _super);
    function MultipleChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultipleChoice.prototype.cssClassName = function () {
        return "multiple-choice";
    };
    MultipleChoice.prototype.mutatedChoiceType = function () {
        return "checkboxChoice";
    };
    return MultipleChoice;
}(ChoiceContainer_1.ChoiceContainer));
exports.MultipleChoice = MultipleChoice;
/**
 * Radio choice consisting of a radio check
 * box.
 *
 * @see {@link ChoiceContainer}
 * @see {@link ChoiceMutator}
 * @see {@link Choice}
 */
var RadioChoice = /** @class */ (function (_super) {
    __extends(RadioChoice, _super);
    function RadioChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioChoice.prototype.inputType = function () {
        return "radio";
    };
    return RadioChoice;
}(Choice_1.Choice));
exports.RadioChoice = RadioChoice;
/**
 * Radio choice consisting of a radio check
 * box.
 *
 * @see {@link ChoiceContainer}
 * @see {@link ChoiceMutator}
 * @see {@link Choice}
 */
var CheckboxChoice = /** @class */ (function (_super) {
    __extends(CheckboxChoice, _super);
    function CheckboxChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxChoice.prototype.inputType = function () {
        return "checkbox";
    };
    return CheckboxChoice;
}(Choice_1.Choice));
exports.CheckboxChoice = CheckboxChoice;
Renderables_1.default.register("singlechoice", SingleChoice);
Renderables_1.default.register("multiplechoice", MultipleChoice);
Renderables_1.default.register("radioChoice", RadioChoice);
Renderables_1.default.register("checkboxChoice", CheckboxChoice);
